import { BuilderExtension } from '@/lib/builder/extension/BuilderExtension'
import { type BuilderState } from '@/lib/builder/types'
import { Store } from '@/lib/store/StoreModule'

import { type CampaignResource, type SmsSection } from '../types'

export interface TextBuilderState {
  templateId?: string | null
}

const textBuilder = Store.extend<
  TextBuilderState,
  BuilderState<CampaignResource, SmsSection>
>(
  {
    actions: {},
    getters: {},
    mutations: {},
    state: {},
  },
  BuilderExtension({
    moduleName: 'textBuilder',
  })
)

const textBuilderModule = Store.createModule(textBuilder, true)

export default textBuilderModule
